<template>
  <el-dialog
    :visible="getNewReceivableModalVisibility"
    title="Create a new Receivable"
    @close="closeModal('newReceivableForm')"
    width="65%"
    class="new-receivable-modal">
    <el-form
      :model="newReceivableForm"
      :rules="newReceivableFormRules"
      ref="newReceivableForm"
      label-width="110px">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="Reference:"
            prop="reference">
            <el-input
              v-model="newReceivableForm.reference"
              class="reference-field"
              placeholder="Insert the receivable reference">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="Customer:"
            prop="selectedCustomerId">
            <el-select
              v-model="newReceivableForm.selectedCustomerId"
              filterable
              :disabled="showCreateNewCustomer"
              v-if="!showCreateNewCustomer"
              placeholder="Select a customer (type to search)">
              <el-option
                v-for="customer in getCustomers"
                :key="customer.id"
                :label="customer.name.toUpperCase()"
                :value="customer.id">
              </el-option>
            </el-select>
            <el-dialog
              class="new-costumer-modal"
              width="55%"
              title="Create a new Customer"
              :visible.sync="showCreateNewCustomer"
              @close="cancelNewCustomerForm('newCustomerForm')"
              append-to-body>
              <el-form
                :model="newCustomerForm"
                :rules="newCustomerFormRules"
                ref="newCustomerForm"
                label-width="150px">
                <el-form-item
                  label="Customer name:"
                  prop="destinationName">
                  <el-input
                    placeholder="Add a name for the new customer"
                    v-model="newCustomerForm.destinationName"></el-input>
                </el-form-item>
                <el-form-item class="buttons">
                  <el-button @click="cancelNewCustomerForm('newCustomerForm')">Cancel</el-button>
                  <el-button
                    type="success"
                    @click="submitNewCustomerForm('newCustomerForm')">Create</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :offset="1"
          :span="8">
          <el-button
            type="text"
            @click="showCreateNewCustomer = true"
            class="btn-block">
            <i class="fa fa-plus"></i> New Customer
          </el-button>
        </el-col>
      </el-row>
      <hr>
      <el-row :gutter="20">
        <el-col>
          <el-switch
            v-model="newReceivableForm.numberOfPayments"
            inactive-color="#1ABB9C"
            active-color="#1ABB9C"
            active-text="2 payments"
            inactive-text="1 payment"
            active-value="2"
            inactive-value="1"
            class="switch-payments">
          </el-switch>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="Payment #1:"
            class="payment-item"
            required>
            <el-col :span="16">
              <el-form-item prop="rtAmount1">
                <masked-input
                  type="text"
                  name="amount"
                  class="amount-input"
                  :mask="getMask"
                  :guide="false"
                  placeholder-char="#"
                  v-model="newReceivableForm.rtAmount1"
                  placeholder="Insert a amount value">
                </masked-input>
              </el-form-item>
            </el-col>
            <el-col
              :offset="1"
              :span="7">
              <el-form-item prop="rtDue1">
                <el-date-picker
                  class="date-input"
                  v-model="newReceivableForm.rtDue1"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="Due Date">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-show="newReceivableForm.numberOfPayments == 2">
        <el-col>
          <el-form-item
            label="Payment #2:"
            required>
            <el-col :span="16">
              <el-form-item prop="rtAmount2">
                <masked-input
                  type="text"
                  name="amount"
                  class="amount-input"
                  :mask="getMask"
                  :guide="false"
                  placeholder-char="#"
                  v-model="newReceivableForm.rtAmount2"
                  placeholder="Insert a amount value">
                </masked-input>
              </el-form-item>
            </el-col>
            <el-col
              :offset="1"
              :span="7">
              <el-form-item prop="rtDue2">
                <el-date-picker
                  class="date-input"
                  v-model="newReceivableForm.rtDue2"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="Due Date">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <br>
      <el-row :gutter="20">
        <el-form-item class="buttons">
          <el-button @click="cancelCreateRT('newReceivableForm')">Cancel</el-button>
          <el-button
            type="success"
            @click="submitNewReceivable('newReceivableForm')">Create Receivable</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export default {
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      hasPO: true,
      createdRtId: null,
      showCreateNewCustomer: false,
      newReceivableForm: {
        reference: '',
        selectedCustomerId: '',
        numberOfPayments: 1,
        rtAmount1: '',
        rtAmount2: '',
        rtDue1: null,
        rtDue2: null,
      },
      newReceivableFormRules: {
        reference: { required: true, message: 'Please insert a reference name', trigger: 'blur' },
        rtAmount1: { required: true, message: 'Please insert an amount', trigger: 'blur' },
        rtAmount2: { required: false, message: 'Please insert an amount', trigger: 'blur' },
        selectedCustomerId: { required: true, message: 'Please select a Customer', trigger: 'blur' },
        rtDue1: [
          { required: true, message: 'Please pick a due date', trigger: 'change' },
        ],
        rtDue2: [
          { required: false, message: 'Please pick a due date', trigger: 'change' },
        ],
      },
      newCustomerForm: {
        destinationName: '',
      },
      newCustomerFormRules: {
        destinationName: { required: true, message: 'Please insert the customer name', trigger: 'blur' },
      },
    };
  },
  computed: {
    ...mapGetters({
      getNewReceivableModalVisibility: 'getNewReceivableModalVisibility',
      getCustomers: 'getCustomers',
      getNewCustomer: 'getNewCustomer',
    }),
    getMask() {
      return createNumberMask({
        prefix: '',
        allowDecimal: true,
      });
    },
    getNewCustomer() {
      this.newCustomerForm.selectedCustomerId = this.getNewCustomer.id;
    },
  },
  created() {
    this.setCustomers();
  },
  methods: {
    ...mapActions({
      setNewReceivableModalVisibility: 'setNewReceivableModalVisibility',
      setCustomers: 'setCustomers',
      setCustomer: 'setCustomer',
      createNewCustomer: 'createNewCustomer',
      createNewReceivable: 'createNewReceivable',
    }),
    closeModal(formName) {
      this.$refs[formName].resetFields();
      this.setNewReceivableModalVisibility(false);
    },
    cancelNewCustomerForm(formName) {
      this.$refs[formName].resetFields();
      this.showCreateNewCustomer = false;
    },
    submitNewCustomerForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const customerObj = {
            name: this.newCustomerForm.destinationName,
          };
          this.$store.dispatch('setCustomer', customerObj);
          this.cancelNewCustomerForm(formName);
          this.$store.dispatch('setCustomers');
          this.setCustomers();
        } else {
          return false;
        }
      });
    },
    submitNewReceivable(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let receivable;
          let amount1 = this.newReceivableForm.rtAmount1;
          while (amount1.indexOf(',') !== -1) {
            amount1 = amount1.replace(',', '');
          }
          if (this.newReceivableForm.numberOfPayments == 2) {
            let amount2 = this.newReceivableForm.rtAmount2;
            while (amount2.indexOf(',') !== -1) {
              amount2 = amount2.replace(',', '');
            }
            receivable = {
              reference: this.newReceivableForm.reference,
              customer: {
                id: this.newReceivableForm.selectedCustomerId,
              },
              receivableTransactions: [
                {
                  amount: amount1,
                  due: this.newReceivableForm.rtDue1,
                },
                {
                  amount: amount2,
                  due: this.newReceivableForm.rtDue2,
                },
              ],
            };
          } else {
            receivable = {
              reference: this.newReceivableForm.reference,
              customer: {
                id: this.newReceivableForm.selectedCustomerId,
              },
              receivableTransactions: [
                {
                  amount: amount1,
                  due: this.newReceivableForm.rtDue1,
                },
              ],
            };
          }
          this.$store.dispatch('getSearchedReceivableTransactionsData');
          this.createNewReceivable(receivable);
          this.$refs.newReceivableForm.resetFields();
          this.setNewReceivableModalVisibility(false);
        } else {
          return false;
        }
        return true;
      });
    },
    cancelCreateRT(formName) {
      this.$refs[formName].resetFields();
      this.setNewReceivableModalVisibility(false);
    },
  },
};
</script>

<style lang="scss">
.new-receivable-modal {
  .switch-payments {
    margin: 0 10px 20px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .checkbox-po {
    margin-left: 10px;
    padding-left: 1px;
  }
  .amount-input {
    width: 100%;
    height: 40px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding-left: 14px;
  }
  .date-input {
    width: 100%;
  }
  .btn-create:disabled {
    background-color: lightgray;
    border: lightgray;
  }
  .reference-field {
    width: 100%;
  }
  .el-select {
    padding-left: 0;
  }
  .el-button--success {
    background-color: #1ABB9C;
    border-color: #1ABB9C;
  }
  .buttons{
    text-align: right;
    padding-right: 5px;
  }
  .el-dialog__title {
    padding-left: 25px;
  }
}
.new-costumer-modal {
  .el-dialog__title{
    padding-left: 25px;
  }
  .buttons{
    text-align: right;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/receivables/partials/CreateReceivable.vue